import React, { useEffect, useRef } from "react";
import "./CalendarDarkMode.css";

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    children: React.ReactNode;
    widthClass?: string;
    allowOverflow?: boolean;
    closeOnOutsideClick?: boolean; // NEW
}

export default function ModalMeet({
    isOpen,
    onClose,
    children,
    widthClass = "max-w-[600px]",
    allowOverflow = true,
    closeOnOutsideClick = false,
}: ModalProps) {
    const overlayRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!isOpen) return;

        const handleEscape = (event: KeyboardEvent) => {
            if (event.key !== "Escape") return;

            // Only the visually topmost calendar modal should react. This keeps
            // nested edit/reschedule/scope dialogs from closing their parent too.
            const modalLayers = Array.from(
                document.querySelectorAll<HTMLElement>('[data-calendar-modal-layer="true"]')
            );
            const topmostLayer = modalLayers[modalLayers.length - 1];

            if (topmostLayer === overlayRef.current) {
                onClose();
            }
        };

        document.addEventListener("keydown", handleEscape);
        return () => document.removeEventListener("keydown", handleEscape);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div
            ref={overlayRef}
            data-calendar-modal-layer="true"
            className="
                fixed inset-0 z-[1000]
                flex items-center justify-center     /* FIXED HERE */
                bg-black/50
                p-4
            "
            onClick={closeOnOutsideClick ? onClose : undefined} 
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className={`
                    w-full ${widthClass}
                    calendar-modal-content theme-scrollbar dark-popup bg-white 
                    rounded-2xl 
                    shadow-xl
                    ${allowOverflow ? 'max-h-[90vh] overflow-y-auto overflow-x-hidden' : ''}
                `}
            >
                {children}
            </div>
        </div>
    );
}
